import type { SectionsCatalogViewMode } from "./sectionsCatalogView";

export function resolveSectionsCatalogViewMode(
  storedMode: SectionsCatalogViewMode,
  isMobile: boolean
): SectionsCatalogViewMode {
  if (isMobile) return "list";
  return storedMode;
}
